import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cityStateFormatter',
  standalone: true,
})
export class CityStateFormatterPipe implements PipeTransform {
  transform(city: string, state: string): string {

    if(city && state) {
      return `${city}, ${state}`;
    } else if(city) {
      return city;
    } else if(state) {
      return state;
    }
    return '';
  }
}
